import React, { useEffect, useState } from "react";
import { Spin, Table } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
  getTradingPair,
  getWithdrawalReq,
  getWithdrawalStatus,
  sendWithdrawalApprovalOtpApi,
  resendWithdrawalApprovalOtpApi,
} from "../../../service/api";
import { Spinner } from "react-bootstrap";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { sanitizeInput } from "../../../config/validation";
import moment from "moment";
import { toast } from "react-toastify";
import { triggerDownload } from "../../../config/downloadUtils";
import AddressCell from "../commoncomponent/AddressCell";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 640,
  maxWidth: "95vw",
  maxHeight: "90vh",
  overflowY: "auto",
  background: "white",
  borderRadius: "10px",
  boxShadow: 24,
  padding: 20,
  outline: "none",
};

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "40px",
    width: "200px",
    minWidth: "120px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    fontSize: "14px",
    padding: "0px 4px",
    backgroundColor: "#fff",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "4px",
  }),
  indicatorSeparator: () => ({ display: "none" }),
};

const STATUS_OPTIONS = [
  { label: "Pending", value: "Pending" },
  { label: "Approved", value: "Approved" },
  { label: "Rejected", value: "Rejected" },
];

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const ALL_COLUMNS = [
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => {
      const content = (
        <>
          <div>
            {r?.user?.firstName} {r?.user?.lastName}
          </div>
          <div>{r?.user?.email}</div>
        </>
      );
      return r?.user?._id ? (
        <Link to={`/admin/user/profile/${r.user._id}`} style={{ textDecoration: "none", cursor: "pointer", color: "inherit" }}>
          {content}
        </Link>
      ) : (
        <div>{content}</div>
      );
    },
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: false,
    render: (r) => r?.user?.email || "-",
  },
  {
    key: "phoneNumber",
    title: "Phone Number",
    defaultVisible: false,
    render: (r) => r?.user?.phoneNumber || "-",
  },
  {
    key: "_id",
    title: "User _id",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?._id || "-"}</span>,
  },
  {
    key: "userId",
    title: "User ID",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?.userId?.toUpperCase() || "-"}</span>,
  },
  {
    key: "amount",
    title: "Amount",
    defaultVisible: true,
    render: (r) =>
      r?.amount !== undefined && r?.amount !== null
        ? `${r?.amount?.toFixed(2) || 0} ${r?.coin?.symbol || ""}`
        : "-",
  },
  {
    key: "amountAfterDeduction",
    title: "Final Amount",
    defaultVisible: false,
    render: (r) =>
      r?.amountAfterDeduction !== undefined && r?.amountAfterDeduction !== null
        ? `${r?.amountAfterDeduction?.toFixed(2) || 0} ${r?.coin?.symbol || ""}`
        : "-",
  },
  {
    key: "coin",
    title: "Coin",
    defaultVisible: false,
    render: (r) => r?.coin?.symbol || "-",
  },
  {
    key: "bankAccountNumber",
    title: "Bank A/c No.",
    defaultVisible: true,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.userBankDetails?.bankAccountNumber || "-"}</span>,
  },
  {
    key: "bankIfsc",
    title: "IFSC Code",
    defaultVisible: true,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.userBankDetails?.bankIfsc || "-"}</span>,
  },
  // {
  //   key: "destinationAddress",
  //   title: "Destination Address",
  //   defaultVisible: true,
  //   render: (r) => <AddressCell address={r?.destinationAddress} />,
  // },
  {
    key: "network",
    title: "Network",
    defaultVisible: false,
    render: (r) => r?.network || "-",
  },
  {
    key: "txHash",
    title: "Tx Hash",
    defaultVisible: false,
    render: (r) => <AddressCell address={r?.txHash} />,
  },
  {
    key: "status",
    title: "Status",
    defaultVisible: true,
    render: (r) => r?.status || "-",
  },
  {
    key: "createdAt",
    title: "Request Date",
    defaultVisible: true,
    render: (r) => formatDateTime(r?.createdAt),
  },
];

const withdrawal = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [edit, setEdit] = useState("");
  const [statusFilter, setStatusFilter] = useState({
    label: "Pending",
    value: "Pending",
  });
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  // Email-OTP step for approve AND reject. `realPayout` comes back from the
  // send-OTP call: true => approving really sends money through TransXT.
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpResending, setOtpResending] = useState(false);
  const [realPayout, setRealPayout] = useState(false);
  const resetOtpState = () => {
    setOtpSent(false);
    setOtp("");
    setOtpError("");
    setOtpSending(false);
    setOtpResending(false);
    setRealPayout(false);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setRejectReason("");
    setRejectReasonError("");
    resetOtpState();
  };
  const [id, setId] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonError, setRejectReasonError] = useState("");
  const [pastList, setPastList] = useState([]);
  const [pastLoading, setPastLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "withdrawal-list-v2",
    allColumns: ALL_COLUMNS,
  });

  const getList = () => {
    const activeStatus = statusFilter?.value;
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
      type: "WITHDRAW",
      status:
        activeStatus === "Approved"
          ? "ACCEPT"
          : activeStatus === "Pending"
          ? "PENDING"
          : "REJECT",
    };
    if (searchTerm) {
      body.search = searchTerm;
    }
    if (startDate) {
      body.startDate = startDate;
    }
    if (endDate) {
      body.endDate = endDate;
    }

    setLoading(true);
    getWithdrawalReq(body)
      .then((res) => {
        if (res?.status) {
          setList(res?.data);
        }
        setLoading(false);
      })
      .finally((res) => {
        setLoading(false);
      });
  };

  const handleDownload = (format) => {
    const activeStatus = statusFilter?.value;
    const body = {
      pagination: false,
      type: "WITHDRAW",
      status: activeStatus === "Approved" ? "ACCEPT" : activeStatus === "Pending" ? "PENDING" : "REJECT",
    };
    if (searchTerm) body.search = searchTerm;
    if (startDate) body.startDate = startDate;
    if (endDate) body.endDate = endDate;
    setDownloadLoading(true);
    getWithdrawalReq(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "withdrawals");
      })
      .finally(() => setDownloadLoading(false));
  };

  const otpAction = edit === "rejecting" ? "REJECT" : "ACCEPT";

  const handleSendOtp = () => {
    if (otpSending || !id?._id) return;
    if (edit === "rejecting" && !rejectReason.trim()) {
      setRejectReasonError("Reject reason is required");
      return;
    }
    setOtpSending(true);
    setOtpError("");
    sendWithdrawalApprovalOtpApi(id._id, otpAction)
      ?.then((res) => {
        if (res?.status) {
          setOtpSent(true);
          setRealPayout(res?.data?.realPayout === true);
          toast.success(res?.message || "OTP sent to your email", { toastId: "withdrawal-send-otp-success" });
        } else {
          toast.error(res?.message || "Failed to send OTP", { toastId: "withdrawal-send-otp-error" });
        }
      })
      ?.catch((e) => toast.error(e?.response?.data?.message || "Failed to send OTP", { toastId: "withdrawal-send-otp-error" }))
      ?.finally(() => setOtpSending(false));
  };

  const handleResendOtp = () => {
    if (otpResending || !id?._id) return;
    setOtpResending(true);
    setOtp("");
    setOtpError("");
    resendWithdrawalApprovalOtpApi(id._id, otpAction)
      ?.then((res) => {
        if (res?.status) {
          setRealPayout(res?.data?.realPayout === true);
          toast.success(res?.message || "A fresh OTP has been sent", { toastId: "withdrawal-resend-otp-success" });
        } else {
          toast.error(res?.message || "Failed to resend OTP", { toastId: "withdrawal-resend-otp-error" });
        }
      })
      ?.catch((e) => toast.error(e?.response?.data?.message || "Failed to resend OTP", { toastId: "withdrawal-resend-otp-error" }))
      ?.finally(() => setOtpResending(false));
  };

  const handleStatus = () => {
    const isRejecting = edit === "rejecting";
    if (isRejecting && !rejectReason.trim()) {
      setRejectReasonError("Reject reason is required");
      return;
    }
    if (!otpSent) { setOtpError("Please request an OTP first"); return; }
    if (!otp.trim()) { setOtpError("Please enter the OTP sent to your email"); return; }

    let body = {
      status: isRejecting ? "REJECT" : "ACCEPT",
      otp: otp.trim(),
    };
    if (isRejecting) {
      body.rejectReason = rejectReason.trim();
    }

    const showError = (msg) => {
      if (/otp/i.test(msg)) setOtpError(msg);
      else toast.error(msg, { toastId: "withdrawal-update-error" });
    };

    setLoadingDelete(true);
    getWithdrawalStatus(id?._id, body)
      .then((res) => {
        if (res?.status) {
          // A real payout can still be in flight (PROCESSING) — tell the admin
          // the bank result will land on its own.
          if (res?.data?.payoutOutcome === "PROCESSING") {
            toast.info(res?.message || "Bank transfer in progress", { toastId: "withdrawal-processing" });
          }
          getList();
          setId(false);
          handleCloseDelete();
        } else {
          showError(res?.message || "Action failed");
        }
      })
      .catch((e) => showError(e?.response?.data?.message || "Action failed"))
      .finally(() => {
        setLoadingDelete(false);
      });
  };

  useEffect(() => {
    getList();
  }, [page, pageSize, statusFilter, searchTerm, startDate, endDate]);

  // Reset to page 1 whenever filters or page size change.
  useEffect(() => {
    setPage(1);
  }, [pageSize, statusFilter, searchTerm, startDate, endDate]);

  // Fetch past withdrawals for the user when modal opens
  useEffect(() => {
    if (!openDelete || !id?.user?._id) {
      setPastList([]);
      return;
    }
    setPastLoading(true);
    getWithdrawalReq({
      page: 1,
      sizePerPage: 10,
      pagination: true,
      type: "WITHDRAW",
      userId: id.user._id,
    })
      .then((res) => {
        if (res?.status) {
          const all = res?.data?.result || [];
          setPastList(all.filter((r) => r._id !== id?._id));
        }
      })
      .finally(() => setPastLoading(false));
  }, [openDelete, id?._id, id?.user?._id]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => (
      <div className="text-end">
        {statusFilter?.value !== "Pending" ? (
          <a
            className="me-1 btn btn-sm bg-success-light "
            onClick={() => {
              setId(row);
              setEdit("View");
              handleOpenDelete();
            }}
          >
            View
          </a>
        ) : (
          <>
            <a
              className="me-1 btn btn-sm bg-success-light "
              onClick={() => {
                setId(row);
                setEdit("View");
                handleOpenDelete();
              }}
            >
              View
            </a>
            <a
              className="me-1 btn btn-sm bg-success-light "
              onClick={() => {
                setId(row);
                setEdit("approving");
                handleOpenDelete();
              }}
            >
              Approve
            </a>
            <a
              onClick={() => {
                setEdit("rejecting");
                setId(row);
                handleOpenDelete();
              }}
              className="me-1 btn btn-sm bg-danger-light"
            >
              Reject
            </a>{" "}
          </>
        )}
      </div>
    ),
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header py-3 mb-2 bg-light border-bottom">
            <div className="row align-items-center">
              {/* Left Section */}
              <div className="col-sm-12">
                <h3 className="page-title mb-2">Withdrawal</h3>
                <ul className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/admin" className="text-decoration-none">
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Withdrawal
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card">
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={list?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                    onRefresh={getList}
                    refreshLoading={loading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin
                          size="large"
                          style={{ position: "relative", top: "35%" }}
                        />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={list ? list?.result : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {list && list?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={list?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${
                          loading ? "display-hide" : "display-flex"
                        }`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                count={list?.total}
                onClear={() => {
                  setSearchTerm("");
                  setStatusFilter({ label: "Pending", value: "Pending" });
                  setStartDate();
                  setEndDate();
                }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="User name or email"
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(sanitizeInput(e.target.value))
                    }
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Status">
                  <Select
                    options={STATUS_OPTIONS}
                    value={statusFilter}
                    onChange={(opt) => setStatusFilter(opt)}
                    styles={customStyles}
                    isSearchable={false}
                    isClearable={false}
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker
                    onApply={handleDateRangeChange}
                    isClearable={true}
                  >
                    <input
                      type="text"
                      placeholder="Select date range"
                      readOnly
                    />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "2px", textAlign: "center" }}>
                  {edit === "View"
                    ? "Withdrawal details"
                    : `Please confirm before ${edit}`}
                </div>

                <div className="d-flex justify-content-center align-items-center mb-2">
                  <span className="fw-bold">
                    {id?.user?.firstName} {id?.user?.lastName}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Amount</span>
                  <span className="fw-bold">
                    {id?.amount} {id?.coin?.symbol}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Date</span>
                  <span className="fw-bold">
                    {moment(id?.createdAt).format("DD/MM/YYYY h:mm")}
                  </span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span>Status</span>
                  <span className="fw-bold">{id?.status}</span>
                </div>
                {/* {id?.destinationAddress && (
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span>Destination Address</span>
                    <span className="fw-bold"><AddressCell address={id.destinationAddress} /></span>
                  </div>
                )} */}
                {id?.network && (
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span>Network</span>
                    <span className="fw-bold">{id.network}</span>
                  </div>
                )}
                {id?.txHash && (
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span>Tx Hash</span>
                    <span className="fw-bold"><AddressCell address={id.txHash} /></span>
                  </div>
                )}

                {(id?.user?.bankAccountHolder ||
                  id?.user?.bankName ||
                  id?.user?.bankAccountNumber ||
                  id?.user?.bankIfsc) && (
                  <div
                    className="mt-3 mb-2 p-2"
                    style={{
                      border: "1px solid #e0e0e0",
                      borderRadius: 6,
                      background: "#fafafa",
                    }}
                  >
                    <div className="fw-bold mb-2">Bank Details</div>
                    {id?.user?.bankAccountHolder && (
                      <div className="d-flex justify-content-between mb-1">
                        <span>Account Holder</span>
                        <span className="fw-bold">{id.user.bankAccountHolder}</span>
                      </div>
                    )}
                    {id?.user?.bankName && (
                      <div className="d-flex justify-content-between mb-1">
                        <span>Bank Name</span>
                        <span className="fw-bold">{id.user.bankName}</span>
                      </div>
                    )}
                    {id?.user?.bankAccountNumber && (
                      <div className="d-flex justify-content-between mb-1">
                        <span>Account Number</span>
                        <span className="fw-bold">{id.user.bankAccountNumber}</span>
                      </div>
                    )}
                    {id?.user?.bankIfsc && (
                      <div className="d-flex justify-content-between mb-1">
                        <span>IFSC</span>
                        <span className="fw-bold">{id.user.bankIfsc}</span>
                      </div>
                    )}
                    {id?.user?.bankVerified !== undefined && (
                      <div className="d-flex justify-content-between mb-1">
                        <span>Verified</span>
                        <span className="fw-bold">
                          {id.user.bankVerified ? "Yes" : "No"}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div
                  className="mt-3 mb-2 p-2"
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 6,
                    background: "#fafafa",
                  }}
                >
                  <div className="fw-bold mb-2">
                    Past Withdrawals
                    {pastList.length > 0 && ` (${pastList.length})`}
                  </div>
                  {pastLoading ? (
                    <div className="text-center py-2">
                      <Spinner size="sm" />
                    </div>
                  ) : pastList.length === 0 ? (
                    <div className="text-muted small">
                      No prior withdrawals for this user.
                    </div>
                  ) : (
                    <div style={{ maxHeight: 220, overflowY: "auto" }}>
                      <table className="table table-sm mb-0" style={{ fontSize: 12 }}>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Coin</th>
                            <th>Amount</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pastList.map((r) => (
                            <tr key={r._id}>
                              <td>{moment(r.createdAt).format("DD/MM/YY HH:mm")}</td>
                              <td>{r?.coin?.symbol || "-"}</td>
                              <td>
                                {r?.amount} {r?.coin?.symbol || ""}
                              </td>
                              <td>
                                <span
                                  className={`badge bg-${
                                    r.status === "ACCEPT"
                                      ? "success"
                                      : r.status === "REJECT"
                                        ? "danger"
                                        : "warning"
                                  }`}
                                >
                                  {r.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {edit === "View" && id?.status === "REJECT" && id?.rejectReason && (
                  <div className="mb-2">
                    <div>Reject Reason</div>
                    <div className="fw-bold" style={{ wordBreak: "break-word" }}>
                      {id.rejectReason}
                    </div>
                  </div>
                )}
                {edit === "View" && id?.status === "REJECT" && (id?.rejectedByEmail || id?.rejectedBy) && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Rejected By</span>
                      <span className="fw-bold">
                        {id?.rejectedByEmail || id?.rejectedBy}
                      </span>
                    </div>
                    {id?.rejectedAt && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span>Rejected At</span>
                        <span className="fw-bold">
                          {moment(id.rejectedAt).format("DD/MM/YYYY HH:mm")}
                        </span>
                      </div>
                    )}
                  </>
                )}
                {edit === "View" && id?.status === "ACCEPT" && (id?.acceptedByEmail || id?.acceptedBy) && (
                  <>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Approved By</span>
                      <span className="fw-bold">
                        {id?.acceptedByEmail || id?.acceptedBy}
                      </span>
                    </div>
                    {id?.acceptedAt && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span>Approved At</span>
                        <span className="fw-bold">
                          {moment(id.acceptedAt).format("DD/MM/YYYY HH:mm")}
                        </span>
                      </div>
                    )}
                  </>
                )}

                {edit === "rejecting" && (
                  <div className="mb-2">
                    <label className="mb-1">
                      Reject Reason <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={3}
                      maxLength={500}
                      placeholder="Enter reason for rejection"
                      value={rejectReason}
                      onChange={(e) => {
                        setRejectReason(e.target.value);
                        if (rejectReasonError) setRejectReasonError("");
                      }}
                    />
                    {rejectReasonError && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {rejectReasonError}
                      </div>
                    )}
                  </div>
                )}

                {(edit === "approving" || edit === "rejecting") && (
                  <div className="mb-2 mt-2">
                    {!otpSent ? (
                      <div style={{ fontSize: 12, color: "#666", textAlign: "center" }}>
                        For security, an OTP will be sent to the admin email before {edit === "approving" ? "approving" : "rejecting"} this withdrawal.
                      </div>
                    ) : (
                      <>
                        {edit === "approving" && (
                          <div
                            className="mb-2"
                            style={
                              realPayout
                                ? { background: "#FEF2F2", border: "1px solid #FCA5A5", color: "#991B1B", borderRadius: 8, padding: "10px 12px", fontSize: 13 }
                                : { background: "#FFFBEB", border: "1px solid #FCD34D", color: "#92400E", borderRadius: 8, padding: "10px 12px", fontSize: 13 }
                            }
                          >
                            {realPayout ? (
                              <>
                                <strong>Real money transfer.</strong> Approving will send {id?.amountAfterDeduction ?? id?.amount} INR to this
                                bank account from the company TransXT account. This cannot be undone.
                              </>
                            ) : (
                              <>
                                <strong>Test mode.</strong> No real money will be sent — approving only marks this withdrawal as accepted.
                              </>
                            )}
                          </div>
                        )}
                        <label className="mb-1">Enter OTP <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={6}
                          autoFocus
                          inputMode="numeric"
                          pattern="\d*"
                          placeholder="6-digit code from email"
                          value={otp}
                          onChange={(e) => {
                            const v = e.target.value.replace(/\D/g, "").slice(0, 6);
                            setOtp(v);
                            if (otpError) setOtpError("");
                          }}
                        />
                        {otpError && <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{otpError}</div>}
                        <div style={{ textAlign: "right", marginTop: 6 }}>
                          <button
                            type="button"
                            onClick={handleResendOtp}
                            disabled={otpResending}
                            className="btn btn-link btn-sm p-0"
                            style={{ fontSize: 12 }}
                          >
                            {otpResending ? "Sending…" : "Resend OTP"}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {statusFilter?.value === "Pending" && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {edit !== "View" &&
                      (!otpSent ? (
                        <button
                          onClick={handleSendOtp}
                          className={`btn ${
                            edit === "approving" ? "btn-success" : "btn-danger"
                          }`}
                          disabled={otpSending}
                          style={{ marginBottom: "10px", marginTop: "15px" }}
                        >
                          {otpSending ? <Spinner size="sm" /> : "Send OTP"}
                        </button>
                      ) : (
                        <button
                          onClick={handleStatus}
                          className={`btn ${
                            edit === "approving" ? "btn-success" : "btn-danger"
                          }`}
                          disabled={loadingDelete || otp.length !== 6}
                          style={{ marginBottom: "10px", marginTop: "15px" }}
                        >
                          {loadingDelete ? (
                            <Spinner size="sm" />
                          ) : edit === "approving" ? (
                            "Approve"
                          ) : (
                            "Reject"
                          )}
                        </button>
                      ))}
                    <button
                      className="btn btn-primary"
                      onClick={handleCloseDelete}
                      style={{
                        marginLeft: "7px",
                        marginBottom: "10px",
                        marginTop: "15px",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default withdrawal;
